import { render, staticRenderFns } from "./a-btn.vue?vue&type=template&id=0e75c60b&scoped=true&"
import script from "./a-btn.vue?vue&type=script&lang=js&"
export * from "./a-btn.vue?vue&type=script&lang=js&"
import style0 from "./a-btn.vue?vue&type=style&index=0&id=0e75c60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75c60b",
  null
  
)

export default component.exports